import { create } from "zustand";

interface IInitState {
	messages: {
		status: string;
		message: string;
		id: number;
	}[];
	addMessage: (status: string, text: string) => void;
	removeMessage: (id: number) => void;
}

const timeout = 5000;

export const useMessageStore = create<IInitState>((set) => ({
	messages: [],
	addMessage: (status, text) => {
		if (!text || text === "") {
			return;
		}
		const id = new Date().getTime();
		const msg = getMessageText(text) || text;

		set((state) => ({
			messages: [...state.messages, { status, message: msg, id }],
		}));

		setTimeout(() => {
			set((state) => ({
				messages: state.messages.filter((message) => message.id !== id),
			}));
		}, timeout);
	},

	removeMessage: (id: number) => {
		set((state) => ({
			messages: state.messages.filter((message) => message.id !== id),
		}));
	},
}));

const getMessageText = (code: string) => {
	try {
		return messageCodes[code];
	} catch (error) {
		return code;
	}
};

const messageCodes: { [key: string]: string } = {
	balance_error: "Ошибка получения баланса",
	payments_network_not_set: "Не указан тип платежей",
	payments_error: "Ошибка получения списка платежей",
	collect_address_not_set: "Не указан адрес для сбора средств",
	collect_coin_not_set: "Не указа тип для сбора средств",
	collect_no_txid: "Ошибка получения хэша транзакции",
	collect_error: "Ошибка сбора средств",
	sync_empty_list: "Не найдено ни одного кошелька для синхронизации",
	sync_error: "Ошибка синхронизации баланса кошельков",
	jwt_expired: "Срок JWT токена истёк",
	jwt_not_found: "JWT токен не найден",
	user_exist: "Такой аккаунт уже существует",
	account_create_error: "Ошибка создания аккаунта",
	user_add_fail: "Ошибка создания нового аккаунта",
	account_not_exist: "Неправильный логин или пароль",
	account_2fa_error: "Указан неправильный 2FAuth токен",
	user_select_fail: "Ошибка поиска аккаунта",
	wrong_wallet_type: "Один из адресов не соответсвует типу выбранной сети",
	amount_undefined: "Не указано количество",
	recepient_undefined: "Не указан адрес отправителя или получателя",
	network_type_undefined: "Тип сети не выбран",
	hash_undefined: "Ошибка получения хэша транзакции",
	transfer_type_undefined: "Тип средств не определён",
	transfer_undefined: "Ошибка перевода средств",
	transaction_data_undefined: "Не указан кошелёк или ID транзакции",
	transaction_add_undefined: "Ошибка добавления транзакции вручную",
	transaction_exist: "Транзакция с таким ID уже существует",
	user_id_not_set: "Пользователь не определён",
	transaction_erc_price_undefined: "Цена токена ERC не установлена",
	transaction_trx_price_undefined: "Цена токена TRX не установлена",

	collect_begin: "Начало сбора средств",
	collect_success: "Сбор средств завершен",
	sync_finished: "Синхронизация завершена",
	"2fa_error": "Указан неправильный 2FAuth токен",
	transfer_success: "Перевод средств закончен",
	transaction_added: "Транзакция добавлена в базу",
};
